import { render } from "./trading.vue?vue&type=template&id=4fca9c4a"
import script from "./trading.vue?vue&type=script&lang=js"
export * from "./trading.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__